import type { IAgencyDigest } from './agencyDigest';

/**
 * Clients whose standing is not 'unknown', which is the one test every verdict about how somebody is
 * doing has to pass: a score or a pill.
 *
 * It decides what a part of daily life with nothing raised about it means. The household's record
 * covers every part of life at once, so "looked at and nothing raised" cannot be told from "nobody
 * was looking" one part at a time, only for the client as a whole, and the baseline is what already
 * answers that. For a client who passes, nothing raised about a part of life is a full wedge. For one
 * who does not, nothing is scored at all.
 *
 * Note the asymmetry it inherits. The baseline's floors withhold the reassuring standings and never a
 * rise, so a client too new to have a normal who nonetheless reads as declining passes this and is
 * scored. That is deliberate: the score is what tells a dispatcher where the decline is.
 */
export const comparableClientIds = (digest: IAgencyDigest): Set<string> => {
    return new Set(
        digest.baselines.filter(baseline => baseline.standing !== 'unknown').map(baseline => baseline.careMapId)
    );
};
